import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Subject } from '../types';
import { getSubjectAndGroupingColumns } from '../utils/subjectColumns';
import {
  SubjectsButton,
  SubjectPageWrapper,
  ActionsContainer
} from '../styled';
import tableColumnUtils from '../../../utils/tableColumnUtils';
import Icons from '../../../components/icons';
import CustomDataGridToolbar from '../../common/components/CustomDataGridToolbar';
import { SchoolClassesConfig } from '../../../types/schoolConfigType';
import { SnackbarSeverityType } from '../../../enums';
import CloneSubjectsModal from './CloneSubjectsModal';
import { dataGridSx } from '../../common/styled/DataGrid';
import pallet from '../../../layouts/pallet';

interface SubjectTableAndActionsProps {
  onEdit: (subject: Subject) => void;
  onDelete: (subject: Subject) => void;
  onAddSubject: (value: boolean) => void;
  subjects: Subject[];
  isLoading: boolean;
  grade: string;
  division: string;
  school: string;
  allClasses?: SchoolClassesConfig;
  onSubjectsCloned: () => void;
  showToast: (message: string, severity: SnackbarSeverityType) => void;
}

const SubjectTableAndActions: React.FC<SubjectTableAndActionsProps> = ({
  onEdit,
  onDelete,
  onAddSubject,
  subjects,
  isLoading,
  grade,
  division,
  school,
  allClasses,
  onSubjectsCloned,
  showToast
}) => {
  const [isCloneSubjectsModalOpen, setIsCloneSubjectsModalOpen] =
    useState(false);
  const columns = getSubjectAndGroupingColumns(onEdit, onDelete);

  return (
    <SubjectPageWrapper>
      <ActionsContainer>
        {subjects.length === 0 && (
          <SubjectsButton onClick={() => setIsCloneSubjectsModalOpen(true)}>
            Clone Subjects
          </SubjectsButton>
        )}
        <SubjectsButton onClick={() => onAddSubject(true)}>
          <Icons.PlusWhite style={{ marginRight: '6px' }} /> Add Subject
        </SubjectsButton>
      </ActionsContainer>
      <DataGrid
        rowHeight={50}
        rows={subjects}
        columns={columns}
        loading={isLoading}
        disableRowSelectionOnClick
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        showToolbar
        slots={{ toolbar: CustomDataGridToolbar }}
        initialState={{
          ...tableColumnUtils.DATA_GRID_INITIAL_STATE,
          columns: {
            ...columns,
            columnVisibilityModel: { id: false }
          }
        }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
      <CloneSubjectsModal
        open={isCloneSubjectsModalOpen}
        onClose={() => setIsCloneSubjectsModalOpen(false)}
        grade={grade}
        division={division}
        allClasses={allClasses}
        school={school}
        onSubjectsCloned={() => {
          setIsCloneSubjectsModalOpen(false);
          onSubjectsCloned();
        }}
        showToast={showToast}
      />
    </SubjectPageWrapper>
  );
};

export default SubjectTableAndActions;
